import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { StoreDialogComponent } from './store-dialog/store-dialog.component';

@Component({
  selector: 'app-index-footer',
  templateUrl: './index-footer.component.html',
  styleUrls: ['./index-footer.component.scss']
})
export class IndexFooterComponent implements OnInit {
  @Input() lang: any;

  constructor(
    private dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
  }

  openStoreDialog(store) {
    let data;
    if (store === 'appStore') {
      data = {
        'store_name': 'App Store',
        'attendance': 'https://apps.apple.com/eg/app/5dma-attendance/id6446276198',
        'provider': 'https://apps.apple.com/eg/app/مزود-خدمة-service-provider/id1601191007',
        'ecommerce': 'https://apps.apple.com/eg/app/5dma-vip-%D8%AE%D8%AF%D9%85%D8%A9-%D9%81%D9%8A-%D8%A7%D9%8A-%D8%A8%D9%8A/id1557248682'
      };
    } else if (store === 'googlePlay') {
      data = {
        'store_name': 'Google Play',
        'attendance': 'https://play.google.com/store/apps/details?id=com.DU.Khedma.attendance',
        'provider': 'https://play.google.com/store/apps/details?id=vip.khedma.khedmavip',
        'ecommerce': ''
      };
    } else if (store === 'appGallery') {
      data = {
        'store_name': 'App Gallery',
        'attendance': 'https://appgallery.huawei.com/app/C108053273',
        'provider': 'https://appgallery.huawei.com/app/C104814699',
        'ecommerce': 'https://appgallery.huawei.com/app/C104516107'
      };
    }

    this.dialog.open(StoreDialogComponent,
      {
        data: data,
      });
  }

}
